// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__3t4J7"};